export default __webpack_public_path__ + "static/media/edgenrw.32928356.04a31e6b.png";